import cx from 'classnames'
import type { FieldRenderProps } from 'react-final-form'

import { isFieldHighlighted } from '@helpers'

import type { DateInputProps } from '@components/ui/InputElements'
import { DateInput } from '@components/ui/InputElements'

type RenderAmountFieldProps = FieldRenderProps<Nullable<string>, HTMLInputElement> &
  Omit<DateInputProps, 'error' | 'helperText' | 'onChange' | 'value' | 'locale' | 'name'> & {
    highlighted?: boolean
    forcedError?: boolean // this is useful for triggering an error state for the field without the actual form field having an error (visibility purposes)
  }

export function RenderDateField({
  className,
  disabled = false,
  forcedError = false,
  highlighted = false,
  input: { name, onChange, onBlur, onFocus, value },
  label,
  meta: { dirtySinceLastSubmit, error, submitError, touched, modifiedSinceLastSubmit },
  required = false,
  ...rest
}: RenderAmountFieldProps) {
  const displayedError = touched && (error || (!dirtySinceLastSubmit && !modifiedSinceLastSubmit && submitError))
  const hasError = Boolean(displayedError || forcedError)

  return (
    <DateInput
      className={cx(className, { 'form-control-error': hasError })}
      disabled={disabled}
      error={hasError}
      helperText={displayedError}
      highlighted={isFieldHighlighted(highlighted, value)}
      id={name}
      label={label}
      name={name}
      onBlur={onBlur}
      onChange={onChange}
      onFocus={onFocus}
      required={required}
      value={value ?? ''}
      {...rest}
    />
  )
}
